import React, { useContext, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { Grid, useMediaQuery, useTheme } from '@material-ui/core';

import PageHeader from 'pages/breakout/components/PageHeader';
import translations from 'utils/translations';
import { BookingBrand } from 'components/BookingForm';
// import InfoDialog from './Dialog/InfoDialog';
import { LoaderContext } from 'context/LoaderContextProvider';
import { VisitsContext } from 'context/VisitsContextProvider';
import InfoDialog from './Agenda/Dialogs/InfoDialog';
import {
  deleteBookingRequest,
  updateBookingRequest,
} from 'entities/agenda/agendaHelper';
import { slotStatus } from 'utils/constants';
import { useEmailHelper } from 'services/emailSender';
import DeleteDialog from './Agenda/Dialogs/DeleteDialog';

const RequestPage = ({ locale }) => {
  //Hooks
  const intl = useIntl();
  const i18n = translations.Agenda(intl).forms;
  const i18nDialogs = translations.Agenda(intl).agenda.page;
  const history = useHistory();
  const emailHelper = useEmailHelper();
  const { setLoaderActive } = useContext(LoaderContext);
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);
  const { selectedSlot, salesTeam, setSelectedSlot } =
    useContext(VisitsContext);
  const mediaTheme = useTheme();
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  // States
  const [infoDialog, setInfoDialog] = useState({
    isOpen: false,
    isError: false,
    customText: '',
    subText: '',
  });
  const [deleteDialog, setDeleteDialog] = useState({
    isOpen: false,
    id: '',
  });
  // Functions
  const handleBack = () => {
    setSelectedSlot({});
    history.push('/');
  };

  const handleConfirm = async (selectedReferent) => {
    let error = true;
    showLoader();
    try {
      const input = {
        id: selectedSlot.id,
        status: slotStatus.CONFIRMED,
        ...(selectedReferent && {
          bookingRequestReferentId: selectedReferent,
        }),
      };
      const res = await updateBookingRequest({ input });

      const reasonParsed = selectedSlot.reason;

      const referent = salesTeam.find((m) => m.id === selectedReferent);

      const start = new Date(selectedSlot.start);
      const end = new Date(selectedSlot.end);

      const data = {
        userName: selectedSlot.givenName,
        userLastname: selectedSlot.familyName,
        userEmail: selectedSlot.email,
        userSalesforceId: selectedSlot.userSalesforceId,
        userCompany: selectedSlot.company || 'N.A.',
        brandName: selectedSlot.brandName,
        brandSalesforceId: selectedSlot.brandSalesforceId,
        brandEmail: selectedSlot.brandEmail,
        date: start.toISOString(),
        start: start.toISOString(),
        end: end.toISOString(),
        pavillion: selectedSlot.pavillion || 'N.A.',
        stand: selectedSlot.stand || 'N.A.',
        ...(referent && {
          referentName: `${referent.familyName} ${referent.givenName}`,
        }),
        note: reasonParsed,
      };
      await emailHelper.sendAgendaEmail({
        type: 'Confirm',
        data,
      });

      error = !!res.error;
    } catch (error) {
      console.error('LOG::  ~ error', error);
    } finally {
      hideLoader();
      setInfoDialog({
        isOpen: true,
        isError: error,
        customText: '',
        subText: i18n.brand.dialogTitleBrandConfirm,
      });
    }
  };
  const handleDelete = (id) => {
    setDeleteDialog({ isOpen: true, id });
  };
  const removeAppointment = async () => {
    let error = true;
    showLoader();
    try {
      const id = deleteDialog.id;
      const input = { id };
      const removed = await deleteBookingRequest({ input });
      const reasonParsed = selectedSlot.reason;

      const referent = selectedSlot.referent;

      const start = new Date(selectedSlot.start);
      const end = new Date(selectedSlot.end);

      const data = {
        userName: selectedSlot.givenName,
        userLastname: selectedSlot.familyName,
        userEmail: selectedSlot.email,
        userSalesforceId: selectedSlot.userSalesforceId,
        userCompany: selectedSlot.company || 'N.A.',
        brandName: selectedSlot.brandName,
        brandSalesforceId: selectedSlot.brandSalesforceId,
        brandEmail: selectedSlot.brandEmail,
        date: start.toISOString(),
        start: start.toISOString(),
        end: end.toISOString(),
        pavillion: selectedSlot.pavillion || 'N.A.',
        stand: selectedSlot.stand || 'N.A.',
        ...(referent && {
          referentName: `${referent.familyName} ${referent.givenName}`,
        }),
        note: reasonParsed,
      };
      await emailHelper.sendAgendaEmail({
        type: 'Rejected',
        data,
      });
      setDeleteDialog({ isOpen: false, id: '' });
      hideLoader();
      // TODO: HANDLE DELETE EMAIL NOTIFICATION

      error = !removed.id;
    } catch (error) {
      console.log('LOG::  ~ error', error);
    } finally {
      hideLoader();
      setInfoDialog({
        isOpen: true,
        isError: error,
        customText: i18n.brand.dialogTitleBrandDeclined,
        subText: '',
      });
    }
  };

  // Renders
  const renderInfoDialog = () => {
    if (!infoDialog.isOpen) return null;
    return (
      <InfoDialog
        onClose={() => {
          setSelectedSlot({});
          setInfoDialog({
            isOpen: false,
            isError: false,
            customText: '',
            subText: '',
          });
          history.push('/');
        }}
        i18n={i18n.brand}
        isSmDown={isSmDown}
        isError={infoDialog.isError}
        context={'brand'}
        customText={infoDialog?.customText || ''}
        subText={infoDialog.subText || ''}
      />
    );
  };

  const renderDeleteDialog = () => {
    if (!deleteDialog.isOpen) return null;
    return (
      <DeleteDialog
        onClose={() => {
          setDeleteDialog({ isOpen: false, id: '' });
        }}
        onAgree={() => removeAppointment()}
        i18n={i18nDialogs.dialogs.delete}
        isSmDown={isSmDown}
        customText={i18nDialogs.dialogs.delete.titleDecline}
        customSubText={i18nDialogs.dialogs.delete.subDecline}
        customDelete={i18nDialogs.dialogs.delete.btn.decline}
      />
    );
  };

  return (
    <Grid container>
      <div style={{ width: '100%' }}>
        {renderInfoDialog()}
        {renderDeleteDialog()}
        <div style={{ width: '90%', margin: '0 auto', maxWidth: 1063 }}>
          <PageHeader
            i18n={i18n.brand}
            isBrandPage={false}
            hasBackBtn={true}
            onBack={handleBack}
          />
          <BookingBrand
            request={selectedSlot}
            salesTeam={salesTeam}
            onConfirm={handleConfirm}
            onDelete={handleDelete}
            locale={locale}
          />
        </div>
      </div>
    </Grid>
  );
};
export default RequestPage;
